<template>
	<div>
		<b-form-group
			label="Welcher Jobtitel soll BewerberInnen angezeigt werden?"
		>
			<b-input v-model="name" @keyup.enter="saveName"/>
		</b-form-group>
		<Button
			text="Speichern"
			icon="checkmark"
			:disabled="!nameValid || saving"
			:loading="saving"
			@click="saveName"
		/>
		<div class="mt-4">
			<b>ACHTUNG:</b> dieser Jobtitel wird den Kandidaten angezeigt und darf daher
			keine Hinweise auf deine Identität und Organisation beinhalten.
		</div>
		<LockInfo class="mt-4">
			Der Jobtitel ist im Nachhinein nicht mehr änderbar.
		</LockInfo>
		<PopUp
			v-if="confirm"
			title="Job-Titel"
			ok-text="Speichern"
			cancel-text="Titel ändern"
			:ok-disabled="saving"
			:ok-loading="saving"
			@ok="saveName"
			@hidden="confirm = false"
		>
			<div>
				<b>{{ name }}</b>
			</div>
			<div class="mt-2">
				Der Titel kann nachträglich nicht mehr geändert werden.<br/>
				Bitte prüfe jetzt nochmals die Rechtschreibung.
			</div>
		</PopUp>
	</div>
</template>
<script>
import Button from "@/vue/common/Button.vue";
import PopUp from "@/vue/common/PopUp.vue";
import {isEmptyOrNull} from "@/helper/String";
import Save from "@/api/customer/job-profile/Save";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import LockInfo from "@/vue/common/LockInfo.vue";

export default {
	components: {
		LockInfo,
		PopUp, Button
	},

	props: {
		jobProfile: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			name: '',
			confirm: false,
			saving: false,
		};
	},

	computed: {
		nameValid ()
		{
			return !isEmptyOrNull(this.name);
		},
	},

	methods: {
		async saveName ()
		{
			if (!this.nameValid)
			{
				return;
			}

			if (!this.confirm)
			{
				this.confirm = true;
				return;
			}

			this.saving = true;

			try
			{
				const response = await new Save()
					.setJobProfileId(this.jobProfile?.id)
					.setData({
						name: this.name
					})
					.call();

				this.confirm = false;

				this.$emit('save', { jobProfile: response.data });
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		},
	}
}
</script>
